import React from 'react';
import PropTypes from 'prop-types';

import { withContainer } from 'core/cache';

import { getMockCredentials } from '../helpers/getMockData';

import ProfileCredentials from '../components/profileCredentials';

const ProfileCredentialsContainer = ({ credentials, gamification, profile, user }) => {
  const isCurrentUser = user.data.id === profile.data.id;
  const isLoading = credentials.status === 'loading';

  return (
    <ProfileCredentials
      data={credentials.data}
      gamification={gamification}
      isCurrentUser={isCurrentUser}
      isLoading={isLoading}
    />
  );
};

ProfileCredentialsContainer.propTypes = {
  credentials: PropTypes.shape({
    status: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.shape({
      credential_type: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
    })).isRequired,
  }).isRequired,
  gamification: PropTypes.shape({
    data: PropTypes.shape({
      is_gold_enabled: PropTypes.bool,
      gold_redeem_url: PropTypes.string,
      has_reached_gold_limit: PropTypes.bool,
      gold_balance: PropTypes.number,
    }).isRequired,
  }).isRequired,
  profile: PropTypes.shape({
    data: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  user: PropTypes.shape({
    data: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
};

export default withContainer(ProfileCredentialsContainer, {
  cache: {
    credentials: {
      getMockedResponse: () => ({ data: getMockCredentials() }),
      getParams: ({ props }) => {
        if (props.match) {
          const { params } = props.match;
          if (params.id) {
            return {
              profileUrl: params.id,
            };
          }
        }
      },
      initialData: [],
      isMocked: false,
      transform: ({ data }) => data.data,
      url: '/api/learner/profile_credentials?profile_url=:profileUrl',
    },
    gamification: { isListener: true },
    profile: { isListener: true },
    user: { isListener: true },
  },
  hasRouter: true,
});
